import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'

import { EmptyContainer } from '../EmptyContainer'
import {
  formatCurrency,
  formatInteger,
  formatInventoryValue,
} from './fnbEodReportUtils'

export default function FnbEodReportInventoryTable({
  items,
  inventoryTrackingAvailable,
  inventorySetupRequired,
}) {
  return (
    <Card body className="card--md">
      <div className="d-flex flex-wrap justify-content-between align-items-baseline gap-2 mb-3">
        <h2 className="h5 mb-0">Inventory &amp; Sales</h2>
        {inventorySetupRequired ? (
          <span className="small text-warning">
            Set beginning inventory for this stand to enable full roll-up.
          </span>
        ) : inventoryTrackingAvailable ? (
          <span className="small text-muted">
            Ending inventory = Available − Sold − Comp − Waste
          </span>
        ) : (
          <span className="small text-muted">
            Select a stand and set beginning inventory to enable roll-up.
          </span>
        )}
      </div>

      {!items?.length ? (
        <EmptyContainer>
          <p className="mb-0 small text-muted">
            No F&amp;B sales recorded for this event, date, and stand.
          </p>
        </EmptyContainer>
      ) : (
        <div className="table-container border-bottom-0 fnb-eod-table-scroll">
          <Table responsive className="mb-0 fnb-eod-table">
            <thead>
              <tr>
                <th className="text-left uppercase text-body">Item</th>
                <th className="text-right uppercase text-body">Beginning</th>
                <th className="text-right uppercase text-body">Received</th>
                <th className="text-right uppercase text-body">Available</th>
                <th className="text-right uppercase text-body">Sold</th>
                <th className="text-right uppercase text-body">Comp</th>
                <th className="text-right uppercase text-body">Waste</th>
                <th className="text-right uppercase text-body">Ending</th>
                <th className="text-right uppercase text-body">Unit Price</th>
                <th className="text-right uppercase text-body">Gross Sales</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.itemId || item.sku || item.itemName}>
                  <td className="text-left">{item.itemName}</td>
                  <td className="text-right">
                    {formatInventoryValue(item.beginningInventory)}
                  </td>
                  <td className="text-right">
                    {formatInventoryValue(item.receivedToday)}
                  </td>
                  <td className="text-right">
                    {formatInventoryValue(item.available)}
                  </td>
                  <td className="text-right">{formatInteger(item.sold)}</td>
                  <td className="text-right">
                    {formatInteger(item.complimentary)}
                  </td>
                  <td className="text-right">{formatInteger(item.waste)}</td>
                  <td className="text-right">
                    {formatInventoryValue(item.endingInventory)}
                  </td>
                  <td className="text-right">
                    {formatCurrency(item.unitPrice)}
                  </td>
                  <td className="text-right">
                    {formatCurrency(item.grossSales)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </Card>
  )
}
